import { useQuery } from "@tanstack/react-query";
import { findAllAttestations } from "../services/users.service";
import { ksAttestationsQK } from "../query-keys";

export const useAttestations = () => {
  return useQuery({
    queryKey: [ksAttestationsQK],
    queryFn: findAllAttestations,
  });
};
